import React, { useEffect, useState } from "react";
import { Waypoint } from "react-waypoint";

const Skills = () => {
  const [animateleft, setAnimateLeft] = useState("");
  const [animateUp, setAnimateUp] = useState("");
  const [animateRight, setAnimateRight] = useState("");

  const handleWaypointEnterLeft = () => {
    setAnimateLeft("visible animate__animated animate__fadeInLeft");
  };
  const handleWaypointEnterUp = () => {
    setAnimateUp("visible animate__animated animate__backInUp");
  };
  const handleWaypointEnterRight = () => {
    setAnimateRight("visible animate__animated animate__fadeInRight");
  };

  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const skillPerElems = document.querySelectorAll(".skill-per");
          skillPerElems.forEach((elem) => {
            const percentage = elem.getAttribute("percentage");
            elem.style.width = `${percentage}%`;
            let animatedValue = 0;
            const intervalId = setInterval(() => {
              if (animatedValue >= percentage) {
                clearInterval(intervalId);
                return;
              }
              elem.style.width = `${animatedValue}%`;
              animatedValue++;
            }, 10);
          });
        }
      });
    });

    const skillsSection = document.querySelector(".skills");
    observer.observe(skillsSection);
  }, []);

  return (
    <section className="skills" id="skills">
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <Waypoint onEnter={handleWaypointEnterRight}>
              <div className={`section-title hide ${animateRight}`}>
                <h1 className="title">Skills</h1>
                <h1 className="title title-fill">My</h1>
              </div>
            </Waypoint>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-7">
            <Waypoint onEnter={handleWaypointEnterLeft}>
              <div className={`skill_bar_section hide ${animateleft}`}>
                <div className="responsive-container-block big-container">
                  <div className="responsive-container-block container">
                    <div className="responsive-cell-block wk-mobile-12 wk-ipadp-9 wk-tab-10 wk-desk-6 left-one">
                      <div className="skills">
                        <div className="skills-name-box">
                          <p className="text-blk skill-name">HTML5/CSS3</p>
                        </div>
                        <div className="skill-bar">
                          <div className="skill-per" percentage="90"></div>
                        </div>
                      </div>
                      <div className="skills">
                        <div className="skills-name-box">
                          <p className="text-blk skill-name">
                            JavaScript/jQuery
                          </p>
                        </div>
                        <div className="skill-bar">
                          <div className="skill-per" percentage="70"></div>
                        </div>
                      </div>
                      <div className="skills">
                        <div className="skills-name-box">
                          <p className="text-blk skill-name">React</p>
                        </div>
                        <div className="skill-bar">
                          <div className="skill-per" percentage="60"></div>
                        </div>
                      </div>
                      <div className="skills">
                        <div className="skills-name-box">
                          <p className="text-blk skill-name">WordPress</p>
                        </div>
                        <div className="skill-bar">
                          <div className="skill-per" percentage="40"></div>
                        </div>
                      </div>
                      <div className="skills">
                        <div className="skills-name-box">
                          <p className="text-blk skill-name">SEO</p>
                        </div>
                        <div className="skill-bar">
                          <div className="skill-per" percentage="70"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Waypoint>
          </div>

          <div className="col-lg-5">
            <Waypoint onEnter={handleWaypointEnterUp}>
              <div className={`right-desc hide ${animateUp}`}>
                <p>
                  As a web developer, I use{" "}
                  <b>HTML5, CSS3, JavaScript, jQuery, WordPress, React.js,</b>{" "}
                  and <b>SEO</b> to create dynamic and optimized websites. My
                  expertise in these technologies allows me to bring
                  interactivity, style, and search engine visibility to my
                  projects. I have a proven track record of delivering
                  high-quality WordPress-based web solutions.
                </p>
              </div>
            </Waypoint>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Skills;
